//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

function useShareRegisterService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getHasOwnerInformationAvailable = (snapshotDate?: Date) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ShareRegisterClient.GetIsOwnershipInformationAvailable({ snapShotDate: snapshotDate })
      .then((res) => res.data);
  };

  const getOwnersAndShares = (filter: WintSuperkollAPIModel.ShareOwnerFilter) => {
    return apiClientInstance(AuthEnums.AuthType.Company).ShareRegisterClient.GetOwnersAndSharesAsync(filter);
  };
  const approveShareRegisterConfirmation = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).ShareRegisterClient.Approve(id);
  };

  const rejectShareRegisterConfirmation = (id: number, reject: WintSuperkollAPIModel.ShareRegisterRejectRequest) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .ShareRegisterClient.Reject(id, {
        comment: reject.comment,
        attachment: reject.attachment,
      })
      .then((res) => res.data);
  };

  const getCompanyHoldings = async (filter: WintSuperkollAPIModel.CompanyHoldingsFilter) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    })
      .ShareRegisterClient.GetCompanyHoldingsAsync(filter)
      .then((res) => res.data);
  };

  return {
    getHasOwnerInformationAvailable,
    getOwnersAndShares,
    approveShareRegisterConfirmation,
    rejectShareRegisterConfirmation,
    getCompanyHoldings,
  };
}

export default useShareRegisterService;
